module.exports = __webpack_public_path__ + "static/media/tsaiga-qhQEyyHWrAQ-unsplash.931ade4b.jpg";